export default __webpack_public_path__ + "30ccce41f9c54e4131a473321dd1c2ff.jpeg";